import ShippingAndReward from './ShippingAndRewards';

export default ShippingAndReward;
